import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { PROMOFLOW_BASE_API_URL } from '../../api/endPoints';
import {
  triggerContentGenerationSuccess,
  triggerContentGenerationFailure,
  fetchFlyerDetailsSuccess,
  fetchFlyerDetailsFailure,
} from '../slices/contentGenerationSlice';

// POST request to trigger content generation
function* triggerContentGenerationSaga(
  action: PayloadAction<{ restaurantId: string; payload: any }>
): Generator<any, void, any> {
  try {
    const { restaurantId, payload } = action.payload;
    const url = `${PROMOFLOW_BASE_API_URL.triggerUrl}/generated_content/trigger/${restaurantId}`;
    
    const response = yield call(axios.post, url, payload);
    const data = response.data;
    
    // Include idea_id and idea_type from the original payload in the success action
    const successData = {
      ...data,
      idea_id: payload.idea_id,
      idea_type: payload.idea_type
    };
    
    yield put(triggerContentGenerationSuccess(successData));
    
    // If seasonal_flyer exists, fetch flyer details
    if (data.seasonal_flyer && data.seasonal_flyer.length > 0) {
      const contentId = data.seasonal_flyer[0].content_id;
      const flyerUrl = `${PROMOFLOW_BASE_API_URL.triggerUrl}/flyers/${restaurantId}?content_id=${contentId}`;
      
      const flyerResponse = yield call(axios.get, flyerUrl);
      const flyerData = flyerResponse.data;
      
      if (flyerData && flyerData.length > 0) {
        yield put(fetchFlyerDetailsSuccess(flyerData[0]));
      }
    }
  } catch (error: any) {
    yield put(
      triggerContentGenerationFailure(
        error.response?.data?.message || error.message || 'Failed to generate content'
      )
    );
    yield put(fetchFlyerDetailsFailure(error.message));
  }
}

export function* contentGenerationWorkflowSaga() {
  yield takeLatest('contentGeneration/triggerContentGenerationRequest', triggerContentGenerationSaga);
}
